const collections = [
  {
    title: '午夜悬疑剧场',
    desc: '烧脑反转不断，适合深夜独自沉浸的悬疑佳作合集',
    count: '48部',
    icon: 'ri-search-2-line',
    bgClass: 'bg-primary-50',
    iconClass: 'text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20cork%20board%20covered%20in%20red%20strings%20and%20photos%2C%20warm%20desk%20lamp%20lighting%2C%20vintage%20noir%20atmosphere%2C%20cinematic%20composition%20with%20amber%20glow%20and%20deep%20shadows&width=600&height=400&seq=index-collection-01&orientation=landscape',
  },
  {
    title: '科幻迷的深夜',
    desc: '硬核科幻与太空史诗，满足你对星辰大海的全部想象',
    count: '36部',
    icon: 'ri-planet-line',
    bgClass: 'bg-accent-50',
    iconClass: 'text-accent-600',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20holographic%20star%20map%20display%2C%20warm%20ambient%20lighting%20from%20control%20panels%2C%20cinematic%20sci-fi%20atmosphere%20with%20golden%20and%20amber%20hues%2C%20clean%20modern%20aesthetic&width=600&height=400&seq=index-collection-02&orientation=landscape',
  },
  {
    title: '深夜美食纪录片',
    desc: '从街头小吃到深夜食堂，用美食治愈每一个不眠夜',
    count: '29部',
    icon: 'ri-bowl-line',
    bgClass: 'bg-secondary-100',
    iconClass: 'text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=Warm%20night%20market%20food%20stall%20with%20steaming%20dishes%20and%20hanging%20lanterns%2C%20golden%20light%20illuminating%20various%20street%20food%2C%20cozy%20atmospheric%20documentary%20style%20photography%20with%20shallow%20depth%20of%20field&width=600&height=400&seq=index-collection-03&orientation=landscape',
  },
  {
    title: '浪漫午夜场',
    desc: '月光下的爱情故事，适合一个人或两个人静静品味',
    count: '42部',
    icon: 'ri-heart-2-line',
    bgClass: 'bg-primary-50',
    iconClass: 'text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20night%20cityscape%20view%20from%20rooftop%20with%20soft%20fairy%20lights%2C%20two%20empty%20chairs%20facing%20skyline%2C%20warm%20golden%20hour%20twilight%20atmosphere%2C%20cinematic%20composition%20with%20dreamy%20bokeh&width=600&height=400&seq=index-collection-04&orientation=landscape',
  },
  {
    title: '极限动作专场',
    desc: '肾上腺素飙升的午夜，飞车追逐与拳拳到肉的硬核爽片',
    count: '55部',
    icon: 'ri-speed-up-fill',
    bgClass: 'bg-accent-50',
    iconClass: 'text-accent-600',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20scene%20with%20motorcycle%20chase%20through%20neon-lit%20city%20street%20at%20night%2C%20motion%20blur%20effect%2C%20warm%20streetlight%20reflections%2C%20intense%20cinematic%20atmosphere%20with%20dramatic%20amber%20lighting&width=600&height=400&seq=index-collection-05&orientation=landscape',
  },
  {
    title: '喜剧解压夜',
    desc: '笑到肚子疼的喜剧合集，用大笑赶走一天的疲惫和压力',
    count: '63部',
    icon: 'ri-emotion-laugh-line',
    bgClass: 'bg-secondary-100',
    iconClass: 'text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20movie%20theater%20interior%20with%20colorful%20popcorn%20and%20vintage%20posters%2C%20warm%20festive%20lighting%2C%20playful%20atmosphere%20with%20retro%20cinema%20aesthetic%2C%20joyful%20composition&width=600&height=400&seq=index-collection-06&orientation=landscape',
  },
  {
    title: '恐怖惊魂夜',
    desc: '胆大夜猫子的专属领域，午夜时分体验真正的脊背发凉',
    count: '37部',
    icon: 'ri-ghost-line',
    bgClass: 'bg-primary-50',
    iconClass: 'text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=Eerie%20dimly%20lit%20corridor%20in%20old%20mansion%20with%20flickering%20candlelight%2C%20atmospheric%20horror%20setting%20with%20warm%20amber%20glow%20and%20deep%20shadows%2C%20cinematic%20suspense%20composition%20with%20vintage%20gothic%20aesthetic&width=600&height=400&seq=index-collection-07&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            按心情与口味精选整理的午夜观影专题
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {collections.slice(0, 7).map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] w-full relative overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className={`absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-lg ${item.bgClass}`}>
                  <i className={`${item.icon} ${item.iconClass} text-sm`}></i>
                </div>
                <div className="absolute bottom-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-black/40 backdrop-blur-sm text-background-50 text-[10px] font-medium">
                    {item.count}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}